import { Box, Button, Heading, Stack, Text } from '@chakra-ui/react'

import { faq } from '@/client/services/url'

import ShwLink from '@/components/ShwLink'
import ModalV3 from '@/components/UI/Modal/ModalV3'

export default function OneTimeAnnouncement({
  onAcknowledgement,
  onClose,
}: {
  onAcknowledgement: () => Promise<void>
  onClose: () => void
}): JSX.Element | null {
  return (
    <ModalV3
      disableClickOutside
      size="md"
      title={() => (
        <Heading flex={1} textAlign="center" size="2xl" mt={5}>
          Before you Continue 🚦✋
        </Heading>
      )}
      body={() => (
        <Box alignItems="center">
          <Stack textAlign="center" direction="column" spacing={4} align="center" mb={5}>
            <Text textAlign="center">
              Please confirm that you have read and agree to ALL the following{' '}
              <ShwLink href={faq.getArticleUrl('volunteer-hour-guidelines')}>
                Volunteer Hours Tracker Guidelines
              </ShwLink>{' '}
              📣
            </Text>
            <Button width="fit-content" onClick={onAcknowledgement}>
              Confirm
            </Button>
          </Stack>
        </Box>
      )}
      open
      onClose={onClose}
    />
  )
}
